import state from './state'
import mutations from './mutations'
import * as actions from './actions'

export default {
	actions,
	mutations,
	state,
	namespaced: true
}
